import { useEffect, useState } from "react";
import { checkActivationTokenAction } from "../actions/check-activation-token.action";
import { resendActivationAction } from "../actions/resent-activation-token.action";

export function useCheckActivationToken() {
  const [isValid, setIsValid] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [maskedUser, setMaskedUser] = useState(null);

  useEffect(() => {
    const pending = JSON.parse(localStorage.getItem("pendingActivationAccount") || "{}");

    async function verify() {
      // Verificar token actual
      try {
        const result = await checkActivationTokenAction({
          uid: pending.uid,
          activationToken: pending.activationToken,
        });

        if (result.data.valid) {
          setIsValid(true);
          setMaskedUser(result?.data?.user);
        } else {
          throw new Error("Token inválido o expirado");
        }
      } catch (err) {
        // Token expirado se pide uno nuevo
        try {
          const res = await resendActivationAction({ uid: pending.uid, oldActivationToken: pending.activationToken });

          localStorage.setItem(
            "pendingActivationAccount",
            JSON.stringify({
              uid: pending.uid,
              activationToken: res.data.activationToken,
            }),
          );

          setIsValid(true);
          setMaskedUser(res);
        } catch (error) {
          setIsValid(false);
        }
      } finally {
        setIsLoading(false);
      }
    }

    verify();
  }, []);

  return { isValid, isLoading, maskedUser };
}
